import { render, staticRenderFns } from "./querySelect.vue?vue&type=template&id=f206d97e&scoped=true"
import script from "./querySelect.vue?vue&type=script&lang=js"
export * from "./querySelect.vue?vue&type=script&lang=js"
import style0 from "./querySelect.vue?vue&type=style&index=0&id=f206d97e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f206d97e",
  null
  
)

export default component.exports